import { IdentityProviderSummaryItemFragment } from '../__generated__/graphql';
import { formatDate } from '../Formatters';

type Summary = Pick<IdentityProviderSummaryItemFragment, 'clientSecretValid' | 'clientSecretMessage' | 'clientSecretCheckedAt'>;

export type SecretState = 'untested' | 'valid' | 'invalid' | 'unknown';

export function secretState(summary: Summary): SecretState {
  if (!summary.clientSecretCheckedAt) return 'untested';
  if (summary.clientSecretValid === true) return 'valid';
  if (summary.clientSecretValid === false) return 'invalid';
  return 'unknown';
}

export const secretStateLabel: Record<SecretState, string> = {
  untested: 'Ikke testet',
  valid: 'Virker',
  invalid: 'Virker ikke',
  unknown: 'Ukjent',
};

export function describeSecret(summary: Summary): string {
  const state = secretState(summary);
  if (state === 'untested') return 'Lagret · ikke testet';
  const when = formatDate(summary.clientSecretCheckedAt, 'DD.MM.YYYY HH:mm');
  return `${summary.clientSecretMessage ?? secretStateLabel[state]} (testet ${when})`;
}
